import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import ModalDialog from '../../../../../components/ModalDialog/ModalDialog.js';
import CarriersColorsDialogForm from './Components/CarriersColorsDialogForm';
import {
	SetFormState, GetCarriersColors
} from '../../../actions/DualMapActions';

const CarriersColorsDialog = (props) => {
	const { author, open, onClose, onApply, className, ...rest } = props;
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.dualMapReducer.formState);
	const userId = useSelector(state => state.session.user.id);
	const role = useSelector(state => state.session.user.role);

	const _onConfirmClick = () => {

	};

	const getData = useCallback(() => {
		dispatch(GetCarriersColors());
	}, []);

	useEffect(() => {
		getData();
	}, []);

	return (
		<ModalDialog
			maxWidth="md"
			onClose={onClose}
			open={open}
			title="Carriers Colors"
			hasConfirm={false}
			cancelLabel="Close"
		>
			<CarriersColorsDialogForm />
		</ModalDialog>

	);
};

CarriersColorsDialog.propTypes = {
	author: PropTypes.object.isRequired,
	className: PropTypes.string,
	onApply: PropTypes.func,
	onClose: PropTypes.func,
	open: PropTypes.bool.isRequired,
};

export default CarriersColorsDialog;
